module.exports = __webpack_public_path__ + "img/card-project5.516bb2de.jpg";